export default __webpack_public_path__ + "static/media/Cremation.578c20aa.mp3";